import React, {FC} from 'react';

import s from '../newsletterSubscription.scss';
import {TermsAndPrivacy} from '../termsAndPrivacy';

export type PropsType = {
    isEnabled?: boolean | null;
    openPrivacyPolicy: () => void;
    openTermsOfUse: () => void;
};

/**
 * SubscriptionPhoneDescription
 */
export const SubscriptionPhoneDescription: FC<PropsType> = ({
    isEnabled,
    openPrivacyPolicy,
    openTermsOfUse,
}) => {
    if (!isEnabled) return null;

    return (
        <p className={s.phoneText}>
            <span>
                By signing up via text, you agree to receive recurring autodialed offers and
                marketing text messages from GlassesUSA.com at the cell phone number you provided to
                us. This consent is not a condition of any purchase. Message & data rates may apply.
                At any time reply STOP to cancel and HELP for customer service. View our{' '}
            </span>
            <TermsAndPrivacy
                openPrivacyPolicy={openPrivacyPolicy}
                openTermsOfUse={openTermsOfUse}
            />
        </p>
    );
};
